










































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {CommonStatus, ComplaintStatus, LadingStatus, ReportDeliveryStatus} from "@/enums/status";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import WardSelector from "@/modules/regions/WardSelector/index.vue";
import LadingSearch from "@/modules/ladings/List/components/Search.vue";
import {ComplaintStore} from "@/modules/complaint/store";
import {FormModel} from "ant-design-vue";
import LadingSelector from "@/shared/components/LadingSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import {singleLadingCodeJoinRelation} from "@/modules/ladings/services";
import {LadingTargetType} from "@/enums/type/ladingtarget";
import {lastByBillLadingRowGuid} from "@/modules/reportdelivery/service";
import moment from 'moment';
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {FORMAT_DATE_TIME_PICKER} from "@/shared/constant";

const lading = {
    rowGuid: "",
    deliveryPostOffice: {
        name: ""
    },
    locationFrom: {
        phoneNumber: "",
        name: "",
        address: "",
        street: {
            name: ""
        },
        ward: {
            name: ""
        },
        district: {
            name: ""
        },
        province: {
            name: ""
        },
    },
    customer: {
        customerCode: ""
    },
    locationTo: {
        phoneNumber: "",
        name: "",
        address: "",
        street: {
            name: ""
        },
        ward: {
            name: ""
        },
        district: {
            name: ""
        },
        province: {
            name: ""
        },
    },
    deliveryTargetType: LadingTargetType,
    status: undefined,
    dateOfAcceptance: "",
    internalNote: "",
    partnerLadingCode: ""
}

@Component({
    name: "ComplaintForm",
    components: {
        LadingSelector,
        LadingSearch,
        WardSelector,
        EmployeeSelector,
        PostOfficeSelector, MillisecondDatePicker, DistrictSelector, ProvinceSelector, EnumSelector
    },
})
export default class extends mixins(CommonMixin) {
    moment = moment();
    labelCol = {span: 6};
    wrapperCol = {span: 14};
    EmployeeType = EmployeeType;
    LadingStatus = LadingStatus;
    LadingTargetType = LadingTargetType;
    @Prop()
    readonly id!: number;
    CommonStatus = CommonStatus;
    ComplaintStatus = ComplaintStatus;

    private address = "";
    private deliveryTarget = "";
    private form = {
        id: undefined,
        handlingEmployeeRowGuid: "",
        content: "",
        status: undefined,
        createdDate: "",
        answer: "",
        billLadingRowGuid: "",
        ladingCode: "",
        receiver: "",
        reportDeliveryDate: "",
        createdBy: "",
        internalNote: "",
        complaintNote: "",
    }
    private billLadingForm = {...lading};
    private rules = {
        billLadingRowGuid: [{required: true, message: "Nhập mã vận đơn", trigger: "change"}],
        handlingEmployeeRowGuid: [{required: true, message: "Chọn nhân viên", trigger: "change"}],
        content: [{required: true, message: "Nhập nội dung khiếu nại", trigger: "change"}],
        status: [{required: true, message: "Nhập trạng thái xử lý", trigger: "change"}]
    };

    private onSubmit() {
        this.isValidLading();
        (this.$refs.formComplaint as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                this.id
                    ? await ComplaintStore.updateComplaint(this.form)
                    : await ComplaintStore.createComplaint(this.form);
                this.$notification.success({
                    message: "Thành công",
                    description: `${this.id ? 'Sửa' : 'Tạo'} khiếu nại thành công`
                });
                this.$router.push({name: "listComplaints"});
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} khiếu nại thất bại`}`
                })
            }
        })
    }

    async created() {
        if (this.id) {
            try {
                const complaint = await ComplaintStore.singleComplaint(this.id);
                this.form = assignValueToForm(this.form, complaint);
                this.billLadingForm = assignValueToForm(this.billLadingForm, complaint.billLading);

                if (complaint.billLading.deliveryEmployee)
                    this.deliveryTarget = complaint.billLading.deliveryEmployee?.fullname + " - " + complaint.billLading.deliveryEmployee.phoneNumber
                if (complaint.billLading.deliveryPartner)
                    this.deliveryTarget = complaint.billLading.deliveryPartner.name;

                if (complaint.createdBy.employee) {
                    this.form.createdBy = complaint.createdBy.employee.employeeCode + " - " + complaint.createdBy.employee.fullname;
                }
                if (complaint.createdBy.customer) {
                    this.form.createdBy = complaint.createdBy.customer.customerCode + " - " + complaint.createdBy.customer.fullName;
                }

                this.billLadingForm.dateOfAcceptance = moment(complaint.billLading.dateOfAcceptance).format(FORMAT_DATE_TIME_PICKER)
                this.address = `${this.billLadingForm.locationTo?.address || ""}, ${this.billLadingForm.locationTo?.street?.name || ""},${this.billLadingForm.locationTo?.ward?.name || ""}, ${this.billLadingForm.locationTo?.district?.name || ""}, ${this.billLadingForm?.locationTo?.province?.name}`.replace(", ,", ", ");
                this.form.ladingCode = complaint.billLading.ladingCode;
                this.form.internalNote = complaint.billLading.internalNote;
                this.form.complaintNote = complaint.complaintNote;
                if (complaint.billLading) {
                    const {data} = await lastByBillLadingRowGuid(complaint.billLading.rowGuid)
                    if (data?.data?.status === ReportDeliveryStatus.PHAT_THANH_CONG) {
                        this.form.receiver = data.data.receiver;
                        this.form.reportDeliveryDate = moment(data.data.reportDeliveryDate).format(FORMAT_DATE_TIME_PICKER);
                    }
                }
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                })
            }
        }
    }

    private async search() {
        this.form.billLadingRowGuid = "";
        this.deliveryTarget = "";
        if (!this.form.ladingCode) return;
        try {
            const {data} = await singleLadingCodeJoinRelation(this.form.ladingCode);
            const lading = data.data;
            this.billLadingForm = assignValueToForm(this.billLadingForm, lading);
            console.log(this.billLadingForm);
            this.form.billLadingRowGuid = lading.rowGuid;

            if (lading.deliveryEmployee)
                this.deliveryTarget = lading.deliveryEmployee?.fullname + " - " + lading.deliveryEmployee.phoneNumber;
            if (lading.deliveryPartner)
                this.deliveryTarget = lading.deliveryPartner.name;
            this.address = `${lading.locationTo?.address || ""}, ${lading.locationTo?.street?.name || ""},${lading.locationTo?.ward?.name || ""}, ${lading.locationTo?.district?.name || ""}, ${lading.locationTo?.province?.name}`.replace(", ,", ", ");

            if (lading) {
                const {data} = await lastByBillLadingRowGuid(lading.rowGuid);
                this.billLadingForm.dateOfAcceptance = moment(lading.dateOfAcceptance).format(FORMAT_DATE_TIME_PICKER)
                if (data?.data?.status === ReportDeliveryStatus.PHAT_THANH_CONG) {
                    this.form.receiver = data.data.receiver;
                    this.form.reportDeliveryDate = moment(data.data.reportDeliveryDate).format(FORMAT_DATE_TIME_PICKER);
                }
            }
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
            })
        }
    }

    isValidLading() {
        if (!this.form.billLadingRowGuid.length) {
            this.$message.error({content: "Quét hoặc nhập mã vận đơn để nhập kho"});
            return false;
        }
    }
}
